import { Icon } from "@iconify/react";
import { getDepartmentIconId } from "../core/constants/departments";

export { default as DepartmentIcon } from "./departments/DepartmentIcon";

const StackedDepartmentIcons = ({
  departments = [],
  size = 32,
  separatorWidth = 1,
  separatorColor = "#212529",
}) => {
  if (!departments.length) return null;

  const iconFor = (dept, index) => (
    <Icon
      key={index}
      icon={getDepartmentIconId(dept)}
      width={departments.length === 1 ? size : "100%"}
      height={departments.length === 1 ? size : undefined}
      style={departments.length > 1 ? { padding: index === 0 ? "0 3px 0 4px" : "0 4px 0 3px" } : undefined}
    />
  );

  if (departments.length === 1) {
    return iconFor(departments[0], 0);
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", height: "80%" }}>
      {iconFor(departments[0], 0)}

      <div
        style={{ minHeight: "100%", backgroundColor: "#3e454d", width: "4px" }}
      />

      {iconFor(departments[1], 1)}
    </div>
  );
};

export default StackedDepartmentIcons;
